import { Warranty } from '@api/types';
import { SmartLink, StyledTableRow, StyledTableRowSeparator, TableCell } from '@components';
import { useAppSelector, useAuth } from '@hooks';
import { getSpecialPage } from '@store/app/app.slice';
import { getWarrantyItems, warrantyListColumns } from './warrantyList.config';

type WarrantyListRowProps = {
  warranty: Warranty;
};

export const WarrantyListRow: React.FC<WarrantyListRowProps> = ({
  warranty,
}: WarrantyListRowProps) => {
  const { isBeremaUser } = useAuth();
  const messageItems = getWarrantyItems({ warranty, isBeremaUser });
  const warrantyDetailsPage = useAppSelector(getSpecialPage('warrantyDetailsPage'));
  return (
    <StyledTableRow iscursorpointer='true'>
      <SmartLink
        href={`${warrantyDetailsPage}?id=${warranty.id}`}
        sx={{ display: 'contents', p: 8 }}
        className='link'
      >
        {messageItems.map((item) => (
          <TableCell
            key={item.fieldName}
            isWorking={false}
            searchWords={[]}
            filteredColumns={warrantyListColumns(isBeremaUser)}
            visibleColumnNames={warrantyListColumns(isBeremaUser).map((warranty) =>
              warranty?.key?.toLowerCase()
            )}
            fieldValue={item.fieldValue}
            fieldName={item.fieldName}
            isBold={item.isBold}
          />
        ))}
        <StyledTableRowSeparator />
      </SmartLink>
    </StyledTableRow>
  );
};
